import {fuzzyMatchSanitized, matchPartsFromSegments} from 'common/util/fuzzy-match';

import {REPLAY_EVENT} from './query-utils';
import {RecordingEventMetadata, RecordingMetadata} from './types';

export function getRelevantReplayEvents(replay: RecordingMetadata): RecordingEventMetadata[] {
  const existingEventMetadata = replay.replayEvents || [];
  return existingEventMetadata.filter((event) => event.eventName !== REPLAY_EVENT);
}

export function getReplayEventCount(replay: RecordingMetadata): number {
  return getRelevantReplayEvents(replay).length;
}

export function getSearchHighlightPieces(
  inputText: string,
  searchFilter: string,
): Array<{text: string; highlight: boolean}> {
  if (!inputText) return [{text: inputText, highlight: false}];

  const match = fuzzyMatchSanitized(inputText.toLowerCase(), searchFilter.toLowerCase());
  if (searchFilter && match) {
    const matchParts = matchPartsFromSegments(inputText, match.segments);

    return matchParts.map((value, i) => {
      return {text: value, highlight: i % 2 === 0};
    });
  } else {
    return [{text: inputText, highlight: false}];
  }
}
